import { MessageType } from '../../chat/chat.model';

export interface CallDataModel {
  id: string;
  type: CallDataType;
  messageType: MessageType;
  text: string;
}

export enum CallDataType {
  connected = 0,
  callEstablished = 1,
  typing = 2,
  message = 3,
  responseCompleted = 4,
  endOfConversation = 5,
  startCall = 6,
  speechRecognized = 7,
  speechStarted = 8,
  speechEnded = 9,
}
